export const ActionTypes = {
  FETCH_ALL: 'services/jobType/fetch_all',
  FETCH_ALL_SUCCESS: 'services/jobType/fetch_all_success',
  SET_LOADER_STATUS: 'services/jobType/set_loader_status',
  SET_ALL: 'services/jobType/set_all',
  ADD_OR_UPDATE_JOB_TYPE: 'services/jobType/add_or_update_jobType',
  DELETE_JOB_TYPE: 'services/jobType/delete_jobType',
};

const fetchAll = ({ jobTypeParams }) => ({
  jobTypeParams,
  type: ActionTypes.FETCH_ALL,
});

const setLoader = ({ showLoader }) => ({
  showLoader,
  type: ActionTypes.SET_LOADER_STATUS,
});

const setAll = ({ allJobType }) => ({
  allJobType,
  type: ActionTypes.SET_ALL,
});

const addorUpdateJobType = ({ jobTypeData, actionName, jobTypeParams }) => ({
  jobTypeData,
  actionName,
  jobTypeParams,
  type: ActionTypes.ADD_OR_UPDATE_JOB_TYPE,
});

const deleteJobType = ({ id, jobTypeParams }) => ({
  id,
  jobTypeParams,
  type: ActionTypes.DELETE_JOB_TYPE,
});

export default {
  fetchAll,
  setAll,
  setLoader,
  addorUpdateJobType,
  deleteJobType,
};
